import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientNegotiateListItem のスタイル
 */
export const hotlineClientNegotiateListItemStyle = tv({
    slots: {
        base: ['relative'],
        button: ['group/pinButton', 'text-0 leading-[0px]'],
        buttonContentWrap: ['inline-flex items-center gap-x-8'],
        buttonWrap: ['absolute top-16 left-4', 'leading-[0px]'],
        checkbox: ['absolute top-[18px] left-28', 'leading-[0px]'],
        item: ['flex justify-between items-start gap-x-8 shrink-0', 'pl-52'],
        numberBadge: ['shrink-0'],
        pinOffIcon: ['group-hover/pinButton:text-secondary'],
        tag: ['block', 'mt-4'],
    },
});
